import { h, render, Component } from 'preact';
class NullComponent extends Component {
  render() {
    return h("p", {}, "component missing for item");
  }
}
export default NullComponent;